import { styled } from '@mui/material';

import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { useWorkspaceView } from './hooks/useWorkspaceView';
import { WorkspaceSkeleton } from './components/WorkspaceSkeleton';
import { ChallengesSection } from './components/ChallengesSection';
import { ReviewsSection } from './components/ReviewsSection';
import { StartPage } from '../../components/StartPage';
import { WorkspaceContext } from './context/WorkspaceContext';
import { usePrototypeWhitelist } from '../../hooks/usePrototypeWhitelist';

const Sections = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  backgroundColor: 'var(--background-background-secondary-color)',
  padding: theme.spacing(2),
  height: '100%',
}));

export const Workspace = () => {
  const {
    isLoading,
    anyChallengesOrAppraisals,
    anyAppraisals,
    anyChallenges,
    fileId,
    fileName,
    workspaceId,
    teamId,
  } = useWorkspaceView();
  const { getMatchedDemoName } = usePrototypeWhitelist();
  const navigate = useNavigate();

  const currentTeam = useCurrentTeamPermissions();
  const [fileDataLoading, setFileDataLoading] = useState<boolean>(true);

  const checkIfUserCanRunSimulationOnFile = async () => {
    if (import.meta.env.VITE_LOCK_NOT_DEMOS !== 'true') {
      setFileDataLoading(false);

      return;
    }

    if (!fileName) return;

    if (!currentTeam || currentTeam.canRunNotDemos()) {
      setFileDataLoading(false);

      return;
    }

    const matchedDemoName = getMatchedDemoName(fileName);

    // if a demo file was opened
    if (matchedDemoName) {
      setFileDataLoading(false);

      return;
    }

    navigate(`/${teamId}/${workspaceId}/upgrade-needed`);
    setFileDataLoading(false);
  };

  useEffect(() => {
    checkIfUserCanRunSimulationOnFile();
  }, [fileName, currentTeam]);

  if (isLoading || fileDataLoading || !fileId) return <WorkspaceSkeleton />;

  if (!anyChallengesOrAppraisals && !isLoading)
    return <StartPage mode="authorized" />;

  return (
    <WorkspaceContext.Provider
      value={{
        fileId,
        anyAppraisals,
        anyChallenges,
        anyChallengesOrAppraisals,
      }}
    >
      <Sections>
        <ChallengesSection />
        <ReviewsSection />
        {/* <NeedAHandSection /> */}
      </Sections>
    </WorkspaceContext.Provider>
  );
};
